export const elIds = {
  hdr_instruct: 'select-options-header',
  stylesheet_id: 'select-option-stylesheet',
  container_id: 'select-option-container',
};

export const uiClasses = {
  radio: 'select-option-issuer-r',
  radioLabel: 'select-option-r-label',
  radioContainer: 'select-option-r-container',
  optionButton: 'select-option-button',
  optionImg: 'option-img',
  optionName: 'option-name',
};
